module.exports = __webpack_public_path__ + "static/media/item10.58354ca2.jpg";